<template>
  <div class="pageContent mobileRecharge">
    <LoadingModal bgcolor="transparent" />
    <div>
      <Top :title="name" :message="tips" />
      <TypeLists :list="arryImg" @selItem="imgClick" />
      <VTitle val="请选择面值" :showLine="false" />
      <ProductDenoList
        v-if="type != 'gouwuka'"
        :list="arryList"
        @selItem="handleSelList"
        :isMember="isMember"
        :active="activeicon2"
        :vip_discount="vip_discount"
      />
      <!-- <TypeList
        v-if="type == 'gouwuka'"
        :status="2"
        :list="arryList"
        :activeIndex="activeicon2"
        @selItem="handleSelList"
        :canSel="true"
        :vip_discount="vip_discount"
      /> -->
      <VTitle val="充值账号" :showLine="false" v-if="name != '购物礼品卡'" />
      <div class="pageBigRadius pageCarServeShadow" v-if="name != '购物礼品卡'">
        <van-field
          v-model="account"
          class="pageBigRadius input"
          :placeholder="
            isQQ
              ? isTx
                ? '请输入QQ号码或手机号码'
                : '请输入QQ号码'
              : isTx
              ? '请输入QQ号码或手机号码'
              : '请输入手机号码'
          "
          @input="input"
          type="number"
          ref="accounts"
          id="accounts"
        />
      </div>
      <VTitle
        val="支付方式"
        :showLine="false"
        v-if="balance > 0 || wechatpay || couponsBalanceList.length > 0"
      />
      <PayWay
        :placeholder="
          isQQ
            ? isTx
              ? '请输入QQ号码或手机号码'
              : '请输入QQ号码'
            : isTx
            ? '请输入QQ号码或手机号码'
            : '请输入手机号码'
        "
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="type == 'gouwuka' ? 4 : 3"
        :params="params"
        :balance="balance"
        :isMember="isMember"
        :typeName="type"
        :vip_discount="vip_discount"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        v-if="balance > 0 || wechatpay || couponsBalanceList.length > 0"
      />
      <Tips :content="describe" v-if="describe != ''" />
    </div>
  </div>
</template>
<script>
import PayWay from "components/PayWay";
import TypeLists from "./ProductTypeList";
import ProductDenoList from "./ProductDenoList";
import { getProductList } from "api/onLine";
import Tips from "server/data/tips.json";
import iconList from "server/data/icon.json";
export default {
  props: {
    name: String,
    cid: Number,
    type: String,
    balance: Number,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TypeLists,
    PayWay,
    ProductDenoList,
  },
  data() {
    return {
      mobile: "",
      arryImg: [],
      arryList: [],
      activeicon1: "0",
      activeicon2: -1,
      sellData: { sell_price: -1 },
      account: "",
      serviceId: null,
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: {},
      isQQ: false,
      isTx: false,
      vip_discount: 0,
    };
  },
  created() {
    this.$store.commit("setPageLoading", true);
    let ident = this.$route.query.ident;
    this.tips = Tips.videoRecharge;
    if (ident == "videoRecharge") {
      this.arryImg = iconList.video;
    } else {
      this.arryImg = iconList.music;
    }
    // this.loadImg();
  },
  destroyed() {},
  mounted() {
    if (this.type != "gouwuka") {
      this.params.type = this.cid;
      this.params.account = "";
    }
    this.loadList(this.arryImg[0].id);
  },
  methods: {
    msgAlert() {
      var inputElem = document.getElementById("accounts");
      if (this.type != "gouwuka" && this.params.account == "") {
        inputElem.focus();
      }
    },
    input() {
      this.params.account = this.account;
    },
    handleClearMobile() {
      this.mobile = null;
    },
    handleSel(i) {
      this.sellData.sell_price = -1;
      this.activeicon2 = -1;
      this.loadList(this.arryImg[i].id);
    },
    handleSelList(i) {
      this.activeicon2 = i;
      // this.sellData.sell_price = this.arryList[i].sell_price;
      this.sellData = {
        ...this.arryList[i],
        sell_price: Number(this.arryList[i].productDenomination),
      };
      //this.sellData =  this.arryList[i];
      this.params.productNo = this.arryList[i].productNo;
      this.params.mouldId = this.mouldId;
    },
    imgClick(index) {
      this.sellData.sell_price = -1;
      this.activeicon2 = -1;
      var pid = this.arryImg[index].id;
      // this.arryList = [];
      if (this.activeicon1 !== index) {
        this.activeicon1 = index;
        this.loadList(pid);
      }
    },
    loadList(pid) {
      getProductList(pid, this.mouldId).then((res) => {
        if (res.status == 200) {
          this.arryList = res.data;
        } else {
          this.arryList = [];
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
  },
};
</script>
<style scoped lang="less">
.mobileRecharge {
  .phone {
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    font-weight: 900;
    font-size: 20px;
    color: var(--redColor);
  }
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
</style>
